import { render, staticRenderFns } from "./modifyPass.vue?vue&type=template&id=3316dc6a&scoped=true"
import script from "./modifyPass.vue?vue&type=script&lang=js"
export * from "./modifyPass.vue?vue&type=script&lang=js"
import style0 from "./modifyPass.vue?vue&type=style&index=0&id=3316dc6a&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3316dc6a",
  null
  
)

export default component.exports